import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider, initI18n } from '@most/i18n';
import { installUnauthorizedHandler } from '@most/auth';
import { ToastProvider } from '@most/ui';
import { App } from './App';
import './styles.css';

const i18n = initI18n();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Regional connectivity is poor; one silent retry, then show the error panel with a
      // retry button rather than spinning forever (docs/06 §4).
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

/**
 * The ONE global 401 handler (docs/06 §3): clear the cache, redirect to the login page.
 *
 * It is a full-page navigation because login belongs to the Next.js landing app, which since
 * D16 is a different ORIGIN — a React Router push cannot leave the origin at all.
 */
installUnauthorizedHandler(queryClient, (to) => {
  window.location.assign(to);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        {/* No basename: since D16 this SPA owns buyer.mostholding.org and is served from
            the root of it, matching vite's `base: '/'`. */}
        <BrowserRouter>
          <ToastProvider>
            <App />
          </ToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </I18nextProvider>
  </React.StrictMode>,
);
